import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DictionaryEntry, TranslationService } from '@sdbn/common';
import { combineLatest } from 'rxjs';


@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DictionarySelectFieldComponent),
            multi: true,
        },
    ],
    selector: 'app-dictionary-select-field',
    templateUrl: './dictionary-select-field.component.html',
    styleUrls: ['./dictionary-select-field.component.scss'],
    standalone: false
})
export class DictionarySelectFieldComponent implements OnInit, ControlValueAccessor {

  @Input() label: string = '';

  @Input() required: boolean = false;

  @Input() dictionaryRoot: string = '';

  dictionaryKeys: Array<string>;

  public readonly formControl = new FormControl(null, []);

  constructor(
    public translationService: TranslationService
  ) { }

  public ngOnInit(): void {

    this.dictionaryKeys = this.getDictionaryKeysStartingWith(this.dictionaryRoot);

    combineLatest([
      this.formControl.valueChanges
    ]).subscribe(() => {
      const value = this._getValue();
      this._onChange(value);
    });
  }

  getDictionaryKeysStartingWith(rootKey: string): string[] {
    const keys: string[] = [];
    this.translationService.dictionary.forEach((value: DictionaryEntry, key: string) => {
      if (key.startsWith(rootKey)) {
        keys.push(key);
      }
    });
    return keys;
  }

  /** Return a Date if the fields are ready or null otherwise */
  private _getValue(): string | null {
    try {
      if (this.formControl.invalid) {
        return null;
      }

      return this.formControl.value;
    } catch {
      // Return null if something throws
      return null;
    }
  }

  public writeValue(value: string | null): void {
    if (value != null) {
      this.formControl.setValue(value);
    } else {
      this.formControl.setValue(null);
    }
  }

  private _onChange = (_value: string | null): void => undefined;
  public registerOnChange(fn: (value: string | null) => void): void {
    this._onChange = fn;
  }

  /** It's called in the component template when we have a "blur" or "input" event */
  public onTouched = (): void => undefined;
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

}
